import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import settings from "../settings";
import { getClientProps } from "../utils";

const { baseApiUrl, vaixClientId } = settings;

export const trackerApi = createApi({
  reducerPath: "trackerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseApiUrl,
    prepareHeaders: (headers, { getState }) => {
      const { apiAuthToken } = getClientProps();
      headers.set("authorization", `Bearer ${apiAuthToken}`);
      headers.set("Content-Type", "application/json");
      vaixClientId && headers.set("x-vaix-client-id", vaixClientId);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    tracker: builder.mutation({
      query: (trackerData) => ({
        url: "/api/tracker/events",
        method: "POST",
        body: trackerData,
      }),
    }),
  }),
});

export const { useTrackerMutation } = trackerApi;
